// extracted by mini-css-extract-plugin
export var pillWrapper = "_y3-0";
export var showOverflow = "_y3-1";